<template>
  <button
    :class="`a-button-primary ${buttonClass}`"
    :type="buttonPrimary.type"
  >
    <i :class="[buttonPrimary.sending
      ? 'far fa-spinner fa-spin' : buttonIcon
      , 'margin-right-xsmall']"></i>
    <span>{{ buttonPrimary.action }}</span>
  </button>
</template>

<script>
export default {
  name: 'AtomButtonPrimary',

  props: {
    buttonPrimary: {
      type: Object,
      default: () => ({
        action: this.$t('mEditionAcademyUsers.buttonPrimary'),
        behavior: 'save',
        class: 'a-button-billing-primary',
        sending: false,
        type: 'submit'
      })
    }
  },

  data () {
    return {
      buttonClass: '',
      buttonIcon: 'far fa-check'
    }
  },

  created () {
    this.setButtonData()
  },

  methods: {
    setButtonData () {
      if (!this.buttonPrimary.behavior) {
        this.buttonPrimary.behavior = 'save'
      }
      this.buttonPrimary.action = this.buttonPrimary.action.toLowerCase()
      switch (this.buttonPrimary.behavior) {
        case 'delete':
          this.buttonClass = `a-button-danger-primary ${this.buttonPrimary.class}`
          this.buttonIcon = 'far fa-trash-alt'
          break

        case 'download':
          this.buttonClass = `a-button-download-primary ${this.buttonPrimary.class}`
          this.buttonIcon = 'fas fa-arrow-to-bottom'
          break

        case 'login':
          this.buttonClass = `a-button-vidroop-primary ${this.buttonPrimary.class}`
          this.buttonIcon = ''
          break

        case 'save':
          this.buttonClass = `a-button-billing-primary ${this.buttonPrimary.class}`
          this.buttonIcon = 'far fa-check'
          break
      }
    }
  }
}
</script>
